import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { translate } from 'translations/translator';
import store from 'state/store';
import { toggleSlideoutMenu } from 'state/modules/ui/actions';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppStoreState } from 'types';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { remCalc } from 'util/style-util';
import { getNewLink, isTeachersGuidePath } from 'util/workbook-util';
import { faHomeAlt } from '@fortawesome/pro-regular-svg-icons';
import { useResources, DRAWER_WIDTH } from 'state/providers/ResourcesProvider';

interface styleProps {
  textColor: string;
  themeColor: string;
  isOpen?: boolean;
  isBook?: boolean;
}

const Header = ({ translationKey, getTitle, endAdornment, isBook }): React.ReactElement => {
  const menuOpen = useSelector(({ ui }: AppStoreState) => ui.globalMenuOpen);
  const currentWorkbook: any = useSelector(({ app }: AppStoreState) => app.currentWorkbook);
  const user: any = useSelector(({ user }: AppStoreState) => user);
  const [{ isOpen }] = useResources();

  const styleProps = {
    themeColor: currentWorkbook && currentWorkbook.primaryColor,
    textColor: currentWorkbook && currentWorkbook.textColor,
    isOpen,
    isBook
  };

  const {
    barsIcon,
    closeIcon,
    heading1,
    header,
    verticalLine,
    endAdornmentClass,
    headerContainer
  } = useStyles(styleProps);

  //This is a temporary fix because currentWorkbook is always a Student Workbook, so you can't do
  //a check against type. isTeachersGuidePath just checks for a '/TG' in the path unti
  //better routes can be set up
  //if (currentWorkbook && currentWorkbook.type === 'teachersGuide') {
  const getHeaderTitle = () =>
    currentWorkbook && isTeachersGuidePath(window.location.pathname)
      ? translate(translationKey, 'teachersGuide')
      : translate(translationKey, getTitle());

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      className={headerContainer}
      id={'mainNavbar'}
      sx={{
        width: isOpen && isBook ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%'
      }}
    >
      <div className={header}>
        <div className={verticalLine} onClick={() => store.dispatch(toggleSlideoutMenu())}>
          {menuOpen ? (
            <FontAwesomeIcon className={closeIcon} icon={faTimes} size="lg" />
          ) : (
            <FontAwesomeIcon className={barsIcon} icon={faBars} size="lg" />
          )}
        </div>
        {currentWorkbook &&
        !window.location.pathname.includes('/home/') &&
        !(user?.clickAways?.length && !user?.licenses?.length) ? (
          <div className={verticalLine}>
            <Link to={getNewLink(currentWorkbook.bookCode, currentWorkbook.edition, 'home')}>
              <FontAwesomeIcon
                style={{ color: currentWorkbook.textColor }}
                className={barsIcon}
                icon={faHomeAlt}
                size="lg"
              />
            </Link>
          </div>
        ) : null}
        <h1 className={heading1}>
          {isBook ? (
            <span>
              {getHeaderTitle()} -{' '}
              <span style={{ fontSize: '22px' }}>{currentWorkbook?.title ?? ''}</span>
            </span>
          ) : (
            `${getHeaderTitle()}`
          )}
        </h1>
      </div>
      <div className={endAdornmentClass}>{endAdornment}</div>
    </Box>
  );
};

const useStyles = makeStyles((theme: any) => ({
  headerContainer: (props: styleProps) => ({
    position: 'sticky',
    top: 0,
    display: 'flex',
    whiteSpace: 'nowrap',
    fontFamily: theme.typography.fontFamily,
    transition: '0.3s',
    height: remCalc(60),
    backgroundColor: props.themeColor ? `${props.themeColor}` : theme.palette.link.main,
    color: props.textColor ? `${props.textColor}` : theme.palette.black.main,
    zIndex: 9
  }),
  endAdornmentClass: props => ({
    backgroundColor: props.themeColor,
    zIndex: 9,
    display: 'flex'
  }),
  header: {
    display: 'flex',
    '@media print': {
      display: 'none'
    }
  },
  heading1: {
    margin: 0,
    fontSize: '28px',
    fontWeight: 400,
    paddingLeft: '27px',
    paddingTop: '11px'
  },
  heading2: {
    margin: '0.3% 0 0.3% 0',
    fontSize: remCalc(24),
    fontWeight: 200
  },
  verticalLine: {
    borderRight: '1px solid black',
    width: '48px',
    fontSize: '18px',
    padding: '10px',
    cursor: 'pointer'
  },
  barsIcon: {
    marginLeft: '12px',
    marginTop: '10px'
  },
  closeIcon: {
    marginLeft: '12px',
    marginTop: '10px'
  }
}));

export default Header;
